/* unplugin-vue-components disabled */import script from "./CampusHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./CampusHeader.vue?vue&type=script&setup=true&lang=js"

import "./CampusHeader.vue?vue&type=style&index=0&id=cf809790&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cf809790"]])

export default __exports__